import { api } from "@/middleware/api";

export const clientLogos = {
  namespaced: true,

  state: () => ({
    clientLogos: [],
  }),

  getters: {
    getById: (state) => (id) => {
      return state.clientLogos.find((p) => p.id === Number(id));
    },
  },

  mutations: {
    SET_CLIENT_LOGOS: (state, payload) => {
      state.clientLogos = payload;
    },
    ADD_CLIENT_LOGO(state, logo) {
      state.clientLogos.push(logo);
    },
    UPDATE_CLIENT_LOGO(state, updated) {
      const index = state.clientLogos.findIndex((p) => p.id === updated.id);
      if (index !== -1) {
        state.clientLogos.splice(index, 1, updated);
      }
    },
    REMOVE_CLIENT_LOGO(state, id) {
      state.clientLogos = state.clientLogos.filter((p) => p.id !== id);
    },
  },

  actions: {
    async fetchClientLogos({ commit }) {
      const { data } = await api.dashboard.adminClientLogosControllerFindAll();
      commit("SET_CLIENT_LOGOS", data.items);
    },
    addClientLogo({ commit }, logo) {
      commit("ADD_CLIENT_LOGO", logo);
    },
    updateClientLogo({ commit }, updated) {
      commit("UPDATE_CLIENT_LOGO", updated);
    },
    async deleteClientLogo({ commit }, id) {
      await api.dashboard.adminClientLogosControllerRemove(id);
      commit("REMOVE_CLIENT_LOGO", id);
    },
  },
};
